import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import axios from "axios";
import React, { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { getTrans as t } from "../../Localization/translations";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import GetAccountingService from "../../services/accounting/addAccountingService";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import { Link,useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddAccountingSetup() {
  const navigate = useNavigate();

  const [transactiontypeget, setTransactionTypeGet] = useState([]);
  const [transactiontype, setTransactionType] = useState("");
  const [accountget, setAccountGet] = useState([]);
  const [account, setAccount] = useState("");
  const [productype, setProductType] = useState("");
  const [dr_cr_code, setDr_Cr_Code] = useState("");
  const [enabled, setEnabled] = useState("");
  const [tablename, setTablename] = useState([]);
  const [columnname, setColumnname] = useState([]);
  const [table_name, setTableName] = useState("");
  const [amountcolumn, setAmountColumn] = useState("");

  const getTranasactiontype = () => {
    GetAccountingService.getTransactiontype().then((response) => {
      setTransactionTypeGet(response.data);
    })
    GetAccountingService.getaccountcode().then((response) => {
      setAccountGet(response.data);
    })
  };
  const AmountObjectView = () => {
    let url = API + "accounting/amountobjectview/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      const uniqueTableNames = new Set();
      const transformedData = response.data.reduce((accumulator, item) => {
        if (!uniqueTableNames.has(item.table_name)) {
          uniqueTableNames.add(item.table_name);
          accumulator.push({
            key: item.table_name,
            value: item.user_table_name,
          });
        }
        return accumulator;
      }, []);

      setTablename(transformedData);
      const uniqueColumnNames = new Set();
      const transformedColumnData = response.data.reduce(
        (accumulatorr, item) => {
          if (!uniqueColumnNames.has(item.column_name)) {
            uniqueColumnNames.add(item.column_name);
            accumulatorr.push({
              key: item.column_name,
              value: item.user_column_name,
            });
          }
          return accumulatorr;
        },
        []
      );

      setColumnname(transformedColumnData);
    })
  };

  const handelClick = ()=>{
    navigate('/accountingsetup')
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const checkBtn = useRef();
  const form = useRef();

  const handleAccountingform = () => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      GetAccountingService.createaccountcode(
        transactiontype,
        productype,
        account,
        dr_cr_code,
        table_name,
        amountcolumn,
        enabled
      ).then((response) => {
        if (response.data.success ===1) {
          setTimeout(() => {
            navigate("/accountingsetup");
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };

  useEffect(() => {
    getTranasactiontype();
    AmountObjectView();
  }, []);

  return (
    <>
      <div className="container-fluid">
        <ToastContainer/>
        <div className="header mb-3 pt-2">
          <h5 className="tc">{t("Add Accounting Setup")}</h5>
          <h6>
            <Link to="/accountingsetup" style={{ color: "grey" }}>
              {t("Accounting Rules")}
            </Link>{" "}
            / <span className="tc">{t("New AccountingSetup")}</span>{" "}
          </h6>
        </div>
        <div className="card">
          <div className="card-body">
            <Form
              role="form text-left"
              onSubmit={handleSubmit(handleAccountingform)}
              ref={form}
              action="."
              method="POST"
              id=""
            >
              {
                <>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Transaction Type")}{" "}
                          <Tooltip content={t("TransactionType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="transactiontype"
                            value={transactiontype}
                            {...register("transactiontype", {
                              onChange: (e) => {
                                setTransactionType(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">
                              {t("Select Transaction Type")}
                            </option>
                            {transactiontypeget.map((key1) => (
                              <option key={key1.id} value={key1.id}>
                                {key1.transaction_type}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.transactiontype &&
                              "Transactiontype is required"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Product Type")}{" "}
                          <Tooltip content={t("ProductType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="producttype"
                            value={productype}
                            {...register("producttype", {
                              onChange: (e) => {
                                setProductType(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">
                              {t("Select Product Type")}
                            </option>
                            <option value="Lease">Lease</option>
                            <option value="Loan">Loan</option>
                            <option value="Rental">Rental</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.producttype && "producttype is required"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Account Code")}{" "}
                          <Tooltip content={t("AccountCode_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="accountcode"
                            value={account}
                            {...register("accountcode", {
                              onChange: (e) => {
                                setAccount(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">
                              {t("Select Account Code")}
                            </option>
                            {accountget.map((key1) => (
                              <option key={key1.id} value={key1.account_code}>
                                {key1.account_code}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.accountcode && "AccountCode is required"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Ammount Object")}{" "}
                          <Tooltip content={t("TransactionType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="amountobject"
                            value={table_name}
                            {...register("amountobject", {
                              onChange: (e) => {
                                setTableName(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">
                              {t("Select Amount Object")}
                            </option>
                            {tablename.map((key1) => (
                              <option key={key1.id} value={key1.key}>
                                {key1.value}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.amountobject && "Amount Object is required"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Ammount Column")}{" "}
                          <Tooltip content={t("TransactionType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="amountcolumn"
                            value={amountcolumn}
                            {...register("amountcolumn", {
                              onChange: (e) => {
                                setAmountColumn(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">
                              {t("Select Amount Column")}
                            </option>
                            {columnname.map((key1) => (
                              <option key={key1} value={key1.key}>
                                {key1.value}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.amountcolumn && "Amount Column is required"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("DR/CR")}{" "}
                          <Tooltip content={t("DR/CR_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="d_c_code"
                            value={dr_cr_code}
                            {...register("d_c_code", {
                              onChange: (e) => {
                                setDr_Cr_Code(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">{t("Select DR/CR")}</option>
                            <option value="D">Debit</option>
                            <option value="C">Credit</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.d_c_code && "DR/CR is required"}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="form-group row">
                        <label className="col-lg-12 col-form-label required">
                          {t("Enabled")}{" "}
                          <Tooltip content={t("Enabled_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <select
                            className="form-control input-lg"
                            name="enabled"
                            value={enabled}
                            {...register("enabled", {
                              onChange: (e) => {
                                setEnabled(e.target.value);
                              },
                              required: true,
                            })}
                          >
                            <option value="">{t("Select Enabled")}</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.enabled && "Enabled is required"}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div className="text-left py-3">
                        <button
                          type="button"
                          onClick={handelClick}
                          className="btn-cancel-contract border-0 btn btn-secondary btn-gradient-primary btn-md"
                        >
                          {t("Cancel")}
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="submit"
                          className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                        >
                          { t("Save")}
                        </button>
                        &nbsp;&nbsp;
                      </div>
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddAccountingSetup;
